import { useState } from 'react';
import { Audience_Status } from '@occc/graphql';

import { useMarkAudienceForSizeCalculation } from '@occc-app/dataAccessLayer/audience/mutations';

type UseAudienceSizeCalculationProps = {
  audienceMembershipCount: number;
  audienceUuid: string;
  status: Audience_Status;
  draftCount?: number | null;
  draftCountCalculationRequestedAt?: string | null;
  lastDraftCountCalculationAt?: string | null;
};

export const useAudienceSizeCalculation = (props: UseAudienceSizeCalculationProps) => {
  const {
    audienceMembershipCount,
    audienceUuid,
    status,
    draftCount,
    draftCountCalculationRequestedAt,
    lastDraftCountCalculationAt,
  } = props;

  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const isDraft = status === Audience_Status.Draft;
  const hasCalculatedCount = draftCount != null;

  const neverCalculated = isDraft && !lastDraftCountCalculationAt;

  const isCalculating = isDraft && !!draftCountCalculationRequestedAt;

  const [markForCalculation, { loading: mutationLoading }] = useMarkAudienceForSizeCalculation({
    onCompleted: () => setShowInfoMessage(true),
  });

  const handleCalculateOrRefresh = () => {
    markForCalculation({ variables: { uuid: audienceUuid }, refetchQueries: ['audience'] });
  };

  const displayCount =
    isDraft && hasCalculatedCount ? (draftCount as number) : audienceMembershipCount;
  const isLoading = mutationLoading;

  return {
    displayCount,
    isLoading,
    isCalculating,
    isDraft,
    hasCalculatedCount,
    showInfoMessage,
    handleCalculateOrRefresh,
    neverCalculated,
  };
};
